import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import $ from '@vaersaagod/tools/Dom';
import * as Events from '../lib/events';

export default el => {
    const OFFSET_BUFFER = 5;
    const OFFSET_TOP = 30;
    const OFFSET_TRANSPARENCY = 150;
    const MOBILE_BREAKPOINT = 750;

    const GROW_AMOUNT = {
        none: 0,
        s: 0,
        sp: 0,
        m: 20,
        mp: 20,
        l: 20,
        lp: 20,
        xl: 20
    };

    const BG_AMOUNT = {
        none: 0,
        s: 0,
        sp: 0,
        m: 40,
        mp: 40,
        l: 40,
        lp: 40,
        xl: 40
    };

    const dom = $(el);

    let isOpen = false;
    const $body = $('body');
    const needsTransparency = $body.hasClass('is-magazine-article') || $body.hasClass('is-about-frontpage') || $body.hasClass('is-404') || $('.hero').hasClass('has-transparent-header');
    let isTransparent = needsTransparency;
    let currentBreakpoint = Viewport.breakpoint;
    let scrollingLocked = false;
    let lastTop = Viewport.scroll.top;
    let headerShowing = true;
    let isSmall = false;
    let growAmount = GROW_AMOUNT[currentBreakpoint.name];
    let bgAmount = BG_AMOUNT[currentBreakpoint.name];
    let content = currentBreakpoint.size < MOBILE_BREAKPOINT ? dom.find('[data-header-bar]') : dom.find('[data-header-content]');

    const bar = dom.find('[data-header-bg]');
    // const logo = dom.find('[data-logo]');
    const nav = dom.find('[data-header-menu]');
    const languageToggle = dom.find('[data-language-selector]');
    const openToggle = dom.find('[data-toggle]');
    const openLines = openToggle.find('span');

    const toggleSize = shouldBeBig => {
        if (shouldBeBig && isSmall) {
            isSmall = false;
            dom.removeClass('is-small');
            TweenMax.to(content.get(0), 0.5, { y: 0, ease: 'Quint.easeOut' });
            TweenMax.to(bar.get(0), 0.5, { y: 0, ease: 'Quint.easeOut' });
            //TweenMax.to(languageToggle.get(0), 0.2, { opacity: 1, ease: 'linear' });
        } else if (!shouldBeBig && !isSmall) {
            isSmall = true;
            dom.addClass('is-small');
            TweenMax.set(content.get(0), { y: -growAmount });
            TweenMax.set(bar.get(0), { y: -bgAmount });
            //TweenMax.set(languageToggle.get(0), { opacity: 0, ease: 'linear' });
        }
    };

    const show = () => {
        if (!headerShowing) {
            console.log('Header.show');
            headerShowing = true;
            TweenMax.to(content.get(0), 0.5, { yPercent: 0, ease: 'Quint.easeOut' });
            TweenMax.to(bar.get(0), 0.5, { yPercent: 0, ease: 'Quint.easeOut' });
            //TweenMax.to(languageToggle.get(0), 0.5, { opacity: 1, ease: 'Quint.easeOut' });
        }
    };

    const hide = () => {
        if (headerShowing) {
            console.log('Header.hide');
            headerShowing = false;
            TweenMax.to(content.get(0), 0.15, { yPercent: -100, ease: 'Quad.easeIn' });
            TweenMax.to(bar.get(0), 0.15, { yPercent: -100, ease: 'Quad.easeIn' });
            //TweenMax.to(languageToggle.get(0), 0.5, { opacity: 0, ease: 'Quint.easeOut' });
            isSmall = lastTop > OFFSET_TOP;
        }
    };

    const toggleTransparency = shouldToggle => {
        if (needsTransparency && shouldToggle) {
            isTransparent = !isTransparent;
            dom.toggleClass('is-opaque');
        }
    };

    const onScroll = () => {
        if (!scrollingLocked) {
            const top = Viewport.scroll.top;
            if (Math.abs(top - lastTop) > OFFSET_BUFFER) {
                const isScrollingUp = top < lastTop;
                if (isScrollingUp) {
                    show();
                    toggleSize(top < OFFSET_TOP);
                    toggleTransparency(!isTransparent && top < OFFSET_TRANSPARENCY);
                } else if (top > OFFSET_TOP) {
                    toggleTransparency(isTransparent && top >= OFFSET_TRANSPARENCY);
                    hide();
                }
                lastTop = top;
            }
        }
    };

    const onBreakpoint = () => {
        const oldBreakpoint = currentBreakpoint;
        currentBreakpoint = Viewport.breakpoint;
        growAmount = GROW_AMOUNT[currentBreakpoint.name];
        bgAmount = BG_AMOUNT[currentBreakpoint.name];
        console.log('onBreakpoint', currentBreakpoint.size);

        if (oldBreakpoint.size >= MOBILE_BREAKPOINT && currentBreakpoint.size < MOBILE_BREAKPOINT) {
            TweenMax.killTweensOf(content.get(0));
            TweenMax.set(content.get(0), { clearProps: 'all' });
            content = dom.find('[data-header-bar]');
        } else if (oldBreakpoint.size < MOBILE_BREAKPOINT && currentBreakpoint.size >= MOBILE_BREAKPOINT) {
            TweenMax.killTweensOf(content.get(0));
            TweenMax.set(content.get(0), { clearProps: 'all' });
            content = dom.find('[data-header-content]');

            if (isOpen) {
                isOpen = false;
                dom.removeClass('is-open');
                TweenMax.killChildTweensOf(openToggle.get(0));
                // TweenMax.killChildTweensOf(logo.get(0));
                TweenMax.set(openLines.nodes, { clearProps: 'all' });
                scrollingLocked = false;
            }
            Viewport.releaseTabbing();
        }

        if (isSmall) {
            isSmall = false;
            toggleSize(false);
        }
    };

    const open = () => {
        if (!isOpen) {
            isOpen = true;
            dom.addClass('is-open');
            TweenMax.killChildTweensOf(openToggle.get(0));
            TweenMax.to(openLines.get(1), 0.3, { opacity: 0, scaleX: 0 });
            TweenMax.to(openLines.get(0), 0.5, { rotation: 45, y: 7, scaleX: 0.9 });
            TweenMax.to(openLines.get(2), 0.5, { rotation: -45, y: -7, scaleX: 0.9 });

            Viewport.lockTabbing([el], openToggle);
        }
    };

    const close = () => {
        if (isOpen) {
            isOpen = false;
            dom.removeClass('is-open');
            TweenMax.killChildTweensOf(openToggle.get(0));
            TweenMax.to(openLines.get(1), 0.5, { opacity: 1, scaleX: 1, clearProps: 'all' });
            TweenMax.to(openLines.get(0), 0.5, { rotation: 0, y: 14, scaleX: 1, clearProps: 'all' });
            TweenMax.to(openLines.get(2), 0.5, { rotation: 0, y: -14, scaleX: 1, clearProps: 'all' });

            Viewport.releaseTabbing(openToggle);
            Viewport.disableTabbingOnElement(nav.get(0));
        }
    };

    const emitMenuOpen = () => {
        Dispatch.emit(Events.MENU_OPEN);
    };

    const emitMenuClose = () => {
        Dispatch.emit(Events.MENU_CLOSE);
    };

    const onOpenClick = e => {
        e.preventDefault();
        emitMenuOpen();
        scrollingLocked = true;
    };

    const onCloseClick = e => {
        e.preventDefault();
        emitMenuClose();
        scrollingLocked = false;
    };

    const onToggle = e => {
        console.log('onToggle');
        if (isOpen) {
            onCloseClick(e);
        } else {
            onOpenClick(e);
        }
    };

    const onScrollLock = () => {
        scrollingLocked = true;
    };

    const onScrollUnlock = () => {
        scrollingLocked = false;
    };

    const onFocus = () => {
        if (!headerShowing) {
            console.log('onFocus');
            show();
            toggleSize(lastTop < OFFSET_TOP);
        }
    };

    const init = () => {
        if (!needsTransparency) {
            dom.addClass('has-opaque-header');
        }
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
        Dispatch.on(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.on(Events.SCROLL_UNLOCKED, onScrollUnlock);
        dom.on('click', '[data-toggle]', onToggle);
        dom.on('focusin', onFocus);
        Viewport.on('scroll', onScroll);
        Viewport.on('breakpoint', onBreakpoint);
        toggleSize(lastTop < OFFSET_TOP);
        
        const top = Viewport.scroll.top;
        toggleTransparency(isTransparent && top >= OFFSET_TRANSPARENCY);
    };

    const destroy = () => {
        dom.off('click');
        dom.off('focusin');
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        Dispatch.off(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.off(Events.SCROLL_UNLOCKED, onScrollUnlock);
        Viewport.off('scroll', onScroll);
        Viewport.off('breakpoint', onBreakpoint);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Header.js